import { render, staticRenderFns } from "./BoxCosts.vue?vue&type=template&id=d59d4ee8"
import script from "./BoxCosts.vue?vue&type=script&lang=js"
export * from "./BoxCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports